import { render, staticRenderFns } from "./ExcluirProduto.vue?vue&type=template&id=7545a63f&scoped=true"
import script from "./ExcluirProduto.vue?vue&type=script&lang=js"
export * from "./ExcluirProduto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7545a63f",
  null
  
)

export default component.exports